// 창업안내 이미지들 import
import imgXr2 from "../image/business-info/business-xr-content.jpg";
import imgXr1 from "../image/digital-content/xr-multi-floor.png";
import imgImage from "../image/business-info/business-update.jpg";

export const businessAdvantages = [
  {
    number: '1',
    title: '자체 개발 고퀄리티 콘텐츠',
    description: '일반적인 디지털 키즈카페와 같이\n외부 콘텐츠를 단순 조합하여 운영는 것이 아닌,\n벅스어드벤처 자체제작 VR·MR·인터랙티브 콘텐츠를 운영해\n콘텐츠 퀄리티와 몰입도에서 차원이 다릅니다.',
    image: imgXr2
  },
  {
    number: '2',
    title: '지속적 콘텐츠 업데이트',
    description: '콘텐츠는 소모되지 않습니다.\n벅스어드벤처는 자체 콘텐츠를 지속 개발하며\n매장별 특성에 맞춘 정기 업데이트로\n항상 새로운 경험을 제공합니다.',
    image: imgImage
  },
  {
    number: '3',
    title: '콘텐츠 기반 공간 설계',
    description: '초기 상담부터 콘텐츠 구성, 설치, 운영 교육까지\n1:1 맞춤형 지원이 가능합니다.\n단순한 공급이 아닌, 콘텐츠 기반 공간을\n함께 설계하는 파트너십을 경험하세요.',
    image: imgXr1
  }
];

export const businessSteps = [
  { 
    number: '1', 
    title: '창업 상담',
    description: '조건, 수익성을 고려한\n전문적인 상담진행'
  },
  { 
    number: '2', 
    title: '현장실사',
    description: '입점점포의 현장상황을 확인해\n최적의 콘텐츠 구성 및 방향 제시'
  },
  { 
    number: '3', 
    title: '계약 & 교육',
    description: '협의된 내용으로 계약 후\n운영에 필요한 교육을 제공'
  },
  { 
    number: '4', 
    title: '인테리어 & 콘텐츠',
    description: '인테리어와 함께\n콘텐츠 및 장비 설치, 점검'
  },
  { 
    number: '5', 
    title: '오픈 & 운영 지원',
    description: '오픈에 필요한 자료 제공 및\n오픈 후에도 지속적으로 지원'
  },
];